import { JsonApiAdapter } from "commons/JsonApiAdapter";
import { BugsnagAdapter } from "commons/BugsnagAdapter";
import LocationAdapter from 'shared/location_adapter';
export default class VoucherActivation {
  constructor() {
    this.requestPath = '/vouchers/activate';
    this.failRedirectPath = '/redeem';
  }

  init() {
  }

  activate(voucher_code) {
    this.showLoadingOverlay();
    this.call(voucher_code);
  }

  async call(voucher_code) {
    return await JsonApiAdapter.rawFetchApi(this.requestPath, this.requestOptions(voucher_code))
      .then((res) => {
        if(res.status == 200) {
          this.callback();
        } else {
          this.failCallback();
        }
      })
      .catch((e) => {
        BugsnagAdapter.notify(this.errorName, e);
      });
  }

  showLoadingOverlay() {
    const loadElement = this.createLoadingOverlay();
    document.body.appendChild(loadElement);
  }

  createLoadingOverlay() {
    const loadElement = document.createElement('div');
    loadElement.classList.add('vidio-loader');
    const loadImage = document.createElement('div');
    loadImage.classList.add('vidio-loader__image');
    loadElement.appendChild(loadImage);
    return loadElement;
  }

  requestOptions(voucher_code) {
    return {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        data: {
          type: 'voucher',
          attributes: {
            code: voucher_code
          }
        }
      })
    }
  }

  callback() {
    LocationAdapter.reload();
  }

  failCallback() {
    LocationAdapter.href(this.failRedirectPath);
  }
}
